module.exports = "/images/alert-menu.svg?3af2250682c71554ab638b0d7e17c3be";